/**
 * Cover images: every Journal entry and every Impact page has one.
 *
 *   journal  a photo of the paper, wherever it was read. Shot landscape on a
 *            phone, so 3:2 is its native frame.
 *   impact   a landing-page photo of the project. 16:9, like a hero.
 *
 * Frontmatter: `image` (URL or a bare filename under /images/<type>/),
 * `imageAlt` (what the photo shows), `imageCaption` (optional; for the
 * journal, where the paper was read).
 */

import { BUCKETS } from "../storage";

/** CSS aspect-ratio of each type's cover. */
export const COVER_RATIO = { journal: "3 / 2", impact: "16 / 9" };

// Assets were copied from the retired bucket with identical paths. BUCKETS is
// read at call time: core/storage imports this module back.
const LEGACY_BUCKET = "storage.googleapis.com/chloelavrat-portfolio/";

function fromLegacyBucket(url) {
	if (!BUCKETS.public) return url;
	return url.replace(LEGACY_BUCKET, `storage.googleapis.com/${BUCKETS.public}/`);
}

/** Resolve a cover value to a URL the browser can load, or null. */
export function coverSrc(type, image) {
	if (!image || typeof image !== "string") return null;
	const value = image.trim();
	if (!value) return null;
	if (/^https?:\/\//.test(value)) return fromLegacyBucket(value);
	if (value.startsWith("/")) return value;
	return `${process.env.PUBLIC_URL || ""}/images/${type}/${value}`;
}

/** Alt text for a cover: the author's description, else the title. */
export function coverAlt(meta = {}) {
	return meta.imageAlt || meta.title || "";
}
